<template>
  <van-popup
    @close="closePopup"
    @opened="getUserList"
    v-model="showiIntervieweePopup"
    round
    position="bottom"
    :style="{ height: '80%' }"
  >
    <div class="interviewee-dialog">
      <van-search
        v-model="searchName"
        show-action
        placeholder="请输入申请人名称"
        @search="onSearch"
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <div v-if="searchNameList.length > 0">
        <div style="color: #999; font-size: 0.75rem">搜索结果</div>
        <div class="interviewee-list">
          <div
            class="interviewee-item"
            @click="clickIntervieweeItem(item, index)"
            v-for="(item, index) in searchNameList"
            :class="{ active: intervieweeIndex == index }"
            :key="item.id"
          >
            {{ item.info }}
          </div>
        </div>
      </div>

      <!-- <div v-if="searchNameList.length <= 0 && hisList.length > 0">
        <div style="color: #999; font-size: 0.75rem">历史搜索</div>
        <div class="interviewee-list">
          <div
            class="interviewee-item"
            @click="clickIntervieweeItem(item, index, 'his')"
            v-for="(item, index) in hisList"
            :class="{ active: intervieweeHisIndex == index }"
            :key="item.id"
          >
            {{item.info }}
          </div>
        </div>
      </div> -->

      <div class="btn-wrap">
        <van-row class="btn-group" gutter="20">
          <van-col :span="24" style="text-align: right">
            <van-button
              type="default"
              block
              @click="showiIntervieweePopup = false"
            >
              取消</van-button
            >
          </van-col>
          <!-- <van-col span="12" v-if="select">
            <van-button type="info" block @click="handleAddPerson"
              >确认</van-button
            >
          </van-col> -->
        </van-row>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: ['pageType','deptId'],

  data() {
    return {
      showiIntervieweePopup: false,
      searchName: '',
      searchNameList: [],
      intervieweeIndex: -1,
      hisList: [],
      intervieweeHisIndex: -1,
      // select: false,
      item: {},
    }
  },
  computed: {
    getSchoolId() {
      let schoolId
      if (this.pageType == 'fk') {
        schoolId = sessionStorage.getItem('qrcodeSchoolId')
      }
      if (this.pageType == 'teacher') {
        schoolId = JSON.parse(localStorage.getItem('userInfo')).schoolId
      }
      if (this.pageType == 'student') {
        schoolId = JSON.parse(localStorage.getItem('userInfo'))
          .patriarchSchoolId
      }
      return schoolId
    },
  },
  created () {
    
  },
  mounted() {
    this.getHistoryDept()
    
  },
  methods: {
    closePopup () {
      // 关闭弹窗清除搜索数据
      this.searchName = '';
      this.searchNameList =  [];
    },  
    async getUserList() {
      this.item = {}
      this.intervieweeIndex = -1
      this.intervieweeHisIndex = -1
      // if (!this.searchName) {
      //   this.$toast('请输入人员姓名')
      //   return false
      // }
      const { data, code } = await this.$https.getTeacherList({
        name: this.searchName,
        deptId: this.deptId,
        schoolId: localStorage.getItem('schoolId')
      })


      if (data && data.length == 0 && code === 200) {
        this.$toast('未搜索到当前人员，请检查后重试')
        this.searchNameList = []
        return false
      }
      if (code !== 200) {
        this.$toast('未搜索到当前人员，请检查后重试')
        this.searchNameList = []
        return false
      }
      this.searchNameList = data.map((item) => {
        item.info = `${item.name} `
        return item
      })
    },
    onSearch() {
      this.getUserList()
    },
    clickIntervieweeItem(item, index, type) {
      this.item = item
      console.log('item',item)
      if (type) {
        this.intervieweeHisIndex = index
      } else {
        // 将当前点击的部门保存至本地历史记录
        let his = JSON.parse(localStorage.getItem('hisDept')) || []
        his.push(item)
        localStorage.setItem('hisDept',JSON.stringify(his))
        this.intervieweeIndex = index
      }
      // this.select = true
      // const { id, name, deptName } = item

      this.$emit('selectItem', { ...item })
      this.showiIntervieweePopup = false
    },

    async getHistoryDept() {
      if (JSON.parse(localStorage.getItem('hisDept'))) {
        console.log(JSON.parse(localStorage.getItem('hisDept')))
        this.hisList = JSON.parse(localStorage.getItem('hisDept'))
      }
     
     
    },
    // handleAddPerson() {

    // },
  },
}
</script>

<style lang="scss" scoped>
.interviewee-dialog {
  padding: 1rem  1rem 1rem;
  
  position: relative;
  height: 100%;
  .interviewee-list {
    margin-bottom: 3rem;
    display: flex;
    padding: 10px 12px;
    flex-wrap: wrap;
    .interviewee-item {
      padding: 0.2rem 0.5rem;
      font-size: 0.9375rem;
      margin-bottom: 1rem;
      color: #171717;
      background: rgba(244, 244, 244, 1);
      border-radius: 0.3125rem;
      margin-right: 0.5rem;
      border: 1px solid transparent;
      &.active {
        border: 1px solid rgba(22, 118, 254, 1);
        background: #fff;
      }
    }
  }
  .btn-wrap {
    position: fixed;
    bottom: 20px;
    left: 1.8rem; 
    right: 2.2rem;
    height: 4rem;
    bottom: 0;
    background-color:#fff;
  }
  .btn-group {
    box-sizing: border-box;
  }
}
</style>
